module.exports = __webpack_public_path__ + "static/media/lvl-group-5.f90a5c50.png";